<div class="anchor-datetime-input"
     [class.anchor-datetime-input--disabled]="isDisabled()"
     (click)="$event.stopPropagation()">

  <!-- Datum-Label -->
  <span class="anchor-datetime-input__date-prefix"
        [class.anchor-datetime-input__date-prefix--is-anchor]="!selectedDate()"
        role="button"
        aria-label="Datum ändern"
        tabindex="0"
        (click)="onDatePrefixClick($event)"
        (keydown.enter)="onDatePrefixClick($event)"
        (keydown.space)="onDatePrefixClick($event)">
    {{ getDisplayDate() }}
  </span>

  <!-- Freitext-Eingabe für Uhrzeit -->
  <input #timeInput
         class="anchor-datetime-input__input"
         type="text"
         [value]="getTimeDisplayValue()"
         [placeholder]="placeholder()"
         [attr.aria-label]="ariaLabel()"
         [disabled]="isDisabled() || null"
         (focus)="onInputFocus($event)"
         (click)="onInputClick()"
         (blur)="onInputBlur($event)" />

  <!-- Clear-Button -->
  @if (hasValue()) {
    <button class="anchor-datetime-input__clear"
            type="button"
            aria-label="Eingabe löschen"
            (click)="onClearClick($event)">
      <TimesIcon />
    </button>
  }

</div>

<!-- Combo-Panel (Kalender + Zeitliste) -->
<p-overlayPanel #op
                role="dialog"
                aria-modal="true"
                appendTo="body"
                styleClass="anchor-datetime-input-overlay"
                (onShow)="onPanelShow()"
                (onHide)="onPanelHide()">
  <div class="anchor-datetime-input__panel-content">

    <p-calendar
      [inline]="true"
      [showTime]="false"
      [defaultDate]="anchorDate()"
      [ngModel]="selectedDate()"
      (onSelect)="onDateSelect($event)"
      [firstDayOfWeek]="1"
      dateFormat="dd.mm.yy"
      [minDate]="calendarMinDate()"
      [maxDate]="calendarMaxDate()">
    </p-calendar>

    <div #timeScrollContainer
         class="anchor-datetime-input__time-scroll"
         role="listbox">
      @for (slot of timeSlots; track slot.minutes) {
        <div class="anchor-datetime-input__time-slot"
             [class.anchor-datetime-input__time-slot--selected]="slot.minutes === selectedMinutes()"
             [class.anchor-datetime-input__time-slot--disabled]="isTimeSlotDisabled(slot.minutes)"
             role="option"
             [attr.aria-selected]="slot.minutes === selectedMinutes()"
             [attr.aria-disabled]="isTimeSlotDisabled(slot.minutes) || null"
             (click)="onTimeSlotClick(slot.minutes)">
          {{ slot.label }}
        </div>
      }
    </div>

  </div>
</p-overlayPanel>
